import { RMGrnService } from '@gtpl/shared-services/raw-material-procurement'; import { Button, Card, Col, Row, Select, Space, Table, Typography } from 'antd'; import type { ColumnsType } from 'antd/es/table'; import React, { useEffect, useMemo, useState } from 'react';

const { Option } = Select; const { Title } = Typography;

const Ledgure = () => {
    const [domesticData,setDomesticData] = useState<any[]>([]);
    const [vendorData,setVendorData] = useState<any[]>([]);
    const [selectedVendor,setSelectedVendor] = useState<number | undefined>(undefined);
    const [loading,setLoading] = useState(false);
    const services = new RMGrnService();

    useEffect(() => { getDomesticPaidVendors(); }, []);

    const getDomesticPaidVendors = () => {
        services.getDomesticPaidVendors().then((res:any) => { 
            if(res.status) 
                setVendorData(res.data || []); 
            else setVendorData([]); 
        }).catch((err:any) => { 
            console.log(err); setVendorData([]); 
        });
    };

    const getLedgerCreateData = () => {
        if(!selectedVendor) return;
        setLoading(true);
        services.getLedgerCreateData({ vendorId:selectedVendor }).then((res:any) => { 
            if(res.status) 
                setDomesticData(res.data || []); 
            else 
                setDomesticData([]); 
        }).catch((err:any) => { 
            console.log(err); 
            setDomesticData([]); 
        }).then(() => setLoading(false), () => setLoading(false));
    };

    const handleReset = () => { 
        setSelectedVendor(undefined); 
        setDomesticData([]); 
    };

   const tableData = useMemo(() => {
        const result: any[] = [];

        domesticData.forEach((invoice: any, invoiceIndex: number) => {
            const vouchers =
                invoice.voucherData &&
                invoice.voucherData.length > 0
                    ? invoice.voucherData
                    : [{ voucher: '-' }];

            vouchers.forEach(
                (voucher: any, voucherIndex: number) => {
                    result.push({
                        key: `${invoice.invoiceNumber}-${voucherIndex}`,

                        invoiceKey: invoice.invoiceNumber,

                        invoiceIndex: invoiceIndex + 1,

                        invoiceNumber: invoice.invoiceNumber,

                        invoiceDate: invoice.invoiceDate,

                        voucher: voucher.voucher,

                        paymentDate: invoice.paymentDate,

                        amount: invoice.amount,

                        finalAmount: invoice.finalAmount,

                        payment: invoice.payment,

                        vendorId: invoice.vendorId,

                        vendor: invoice.vendor,

                        voucherIndex: voucherIndex,

                        voucherCount: vouchers.length
                    });
                }
            );
        });

        return result;
    }, [domesticData]);

    const formatNumber = (value:any) => { 
        if(value === null || value === undefined || value === '') 
            return '-'; 
        const number = Number(value); 
        return Number.isNaN(number) ? value : number.toLocaleString('en-IN',{maximumFractionDigits:2}); 
    };

    const formatDate = (value:any) => { 
        if(!value) return '-';
        const date = new Date(value);
        if(Number.isNaN(date.getTime()))
         return value; return date.toLocaleDateString('en-GB'); 
         };

const columns: any[] = [
    {
        title: 'S.No',
        key: 'sno',
        width: 70,
        align: 'center',
        render: (_: any, __: any, index: number) => index + 1,
        sorter: (a: any, b: any) => {
            return domesticData.indexOf(a) - domesticData.indexOf(b);
        },
        sortDirections: ['descend', 'ascend']
    },
    {
        title: 'Vendor',
        dataIndex: 'vendor',
        key: 'vendor',
        sorter: (a: any, b: any) => {
            return String(a?.vendor || '').localeCompare(
                String(b?.vendor || ''),
                undefined,
                { numeric: true }
            );
        },
        sortDirections: ['descend', 'ascend']
    },

    {
        title: 'Invoice Number',
        dataIndex: 'invoiceNumber',
        key: 'invoiceNumber',
        sorter: (a: any, b: any) => {
            return String(a?.invoiceNumber || '').localeCompare(
                String(b?.invoiceNumber || ''),
                undefined,
                { numeric: true }
            );
        },
        sortDirections: ['descend', 'ascend']
    },

    {
        title: 'Invoice Date',
        dataIndex: 'invoiceDate',
        key: 'invoiceDate',
        render: (text: any) => {
            if (!text) return '-';

            const date = new Date(text);

            return date.toLocaleDateString('en-GB');
        },
        sorter: (a: any, b: any) => {
            return (
                new Date(a?.invoiceDate || 0).getTime() -
                new Date(b?.invoiceDate || 0).getTime()
            );
        },
        sortDirections: ['descend', 'ascend']
    },

    {
        title: 'Voucher',
        dataIndex: 'voucherData',
        key: 'voucherData',

        render: (text: any, record: any) => {
            return record?.voucherData?.map(
                (data: any, index: number) => {

                    const tag =
                        index !== record?.voucherData?.length - 1
                            ? (
                                <hr
                                    style={{
                                        marginTop: '0rem',
                                        marginBottom: '0rem'
                                    }}
                                />
                            )
                            : <></>;

                    return (
                        <React.Fragment key={index}>
                            {data?.voucher || '-'}
                            {tag}
                        </React.Fragment>
                    );
                }
            );
        },

        sorter: (a: any, b: any) => {
            const voucherA =
                a?.voucherData?.[0]?.voucher || '';

            const voucherB =
                b?.voucherData?.[0]?.voucher || '';

            return voucherA.localeCompare(
                voucherB,
                undefined,
                { numeric: true }
            );
        },

        sortDirections: ['descend', 'ascend']
    },

    {
        title: 'Payment Date',
        dataIndex: 'paymentDate',
        key: 'paymentDate',

        render: (text: any) => {
            if (!text) return '-';

            const date = new Date(text);

            return date.toLocaleDateString('en-GB');
        },

        sorter: (a: any, b: any) => {
            return (
                new Date(a?.paymentDate || 0).getTime() -
                new Date(b?.paymentDate || 0).getTime()
            );
        },

        sortDirections: ['descend', 'ascend']
    },

    {
        title: 'Invoice Amount',
        dataIndex: 'amount',
        key: 'amount',

        render: (text: any) => {
            if (
                text === null ||
                text === undefined ||
                text === ''
            ) {
                return '-';
            }

            return Number(text).toLocaleString(
                'en-IN',
                {
                    maximumFractionDigits: 2
                }
            );
        },

        sorter: (a: any, b: any) => {
            return (
                Number(a?.amount || 0) -
                Number(b?.amount || 0)
            );
        },

        sortDirections: ['descend', 'ascend']
    },

    {
        title: 'Payment',
        dataIndex: 'payment',
        key: 'payment',

        render: (text: any) => {
            if (
                text === null ||
                text === undefined ||
                text === ''
            ) {
                return '-';
            }

            return Number(text).toLocaleString(
                'en-IN',
                {
                    maximumFractionDigits: 2
                }
            );
        },

        sorter: (a: any, b: any) => {
            return (
                Number(a?.payment || 0) -
                Number(b?.payment || 0)
            );
        },

        sortDirections: ['descend', 'ascend']
    }
];

    return (
<Card
      title={<span style={{ color: 'white' }}>Ledgure</span>}
      style={{ margin: 20 }}
      headStyle={{
        backgroundColor: '#69c0ff',
        border: 0,
        textAlign: 'center',
      }}
//        extra={
//     <Link to="/rm-vendor-po-view">
//       <Button type="default">View</Button>
//     </Link>
//   }
  >            <Row gutter={[16,16]} align="middle">
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Select placeholder="Select Vendor" value={selectedVendor} onChange={(value:number) => setSelectedVendor(value)} style={{width:'100%'}} allowClear>
                        {vendorData.map((vendor:any) => <Option key={vendor.vendorId} value={vendor.vendorId}>{vendor.vendor}</Option>)}
                    </Select>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Space>
                        <Button type="primary" onClick={getLedgerCreateData} disabled={!selectedVendor} loading={loading}>Submit</Button>
                        <Button onClick={handleReset}>Reset</Button>
                    </Space>
                </Col>
            </Row>

            <div style={{marginTop:24}}>
                <Table
                bordered
                loading={loading}
                columns={columns}
                dataSource={domesticData}
                rowKey={(record: any) => record.invoiceNumber}
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true
                }}
                scroll={{ x: 1100 }}
            />
            </div>
        </Card>
    );
};

export default Ledgure;